import React from "react";
import { Modal, Button } from "react-bootstrap";

import { apiDeleteEngagement } from "../../../api/ApiEngagement";
import { useTranslation } from "react-i18next";

const ModalDelete = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;

  const submitDelete = async () => {
    await apiDeleteEngagement(id);
    handleRecupDatas();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminEngagements.modalDeleteTitre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body> {t("admin.PageAdminEngagements.modalDeleteText")}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitDelete}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
